import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppDispatch } from '../../../../../../../../../app/redux/hooks';
import { debounce } from '../../../../../../../../../utils/commonFunctions';
import {
  cleargetVehicleListDetailsAction,
  getVehicleListDetailsAction
} from '../../../../../../../../../features/yaantrac/redux/reducer/yaantracSlices/vehicleList';

interface Vehicle {
  id: number;
  vehicleNumber: string;
  vehicleType: string;
  driverName: string;
  fuelType: string;
  vehicleCategory: string;
  transmissionType: string;
  vehicleMake: string;
  seatingCapacity: number | null;
  numberOfAxles: number | null;
}

export const useVehicleCardHooks = ({ setApi, clearState, vehicleList }: any) => {
  const dispatch = useAppDispatch();
  const abortController = useRef<AbortController | null>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [vehicleDetails, setVehileDetails] = useState(null);
  const [vehicleDatas, setVehileDatas] = useState<Vehicle[]>([]);
  const [filter, setFilter] = useState('');
  const [pageno, setPageno] = useState<number>(1);
  const [isScroll, setIsScroll] = useState<boolean>(false);
  const inputRef = useRef<any>();

  const handleOpenVehicle = (items: any) => {
    setIsOpen(true);
    setVehileDetails(items);
  };

  const handleFilterChange = useCallback(
    debounce(async (event: string) => {
      setFilter(event);
      const payload = {
        pageno: pageno,
        search: event,
        pagesize: 16
      };
      clearState();
      await dispatch(cleargetVehicleListDetailsAction());
      await dispatch(getVehicleListDetailsAction(payload));
    }),
    []
  );

  const handleInfinitePagination = async (pageNo: number) => {
    setIsScroll(true);
    await dispatch(getVehicleListDetailsAction({ pageno: pageNo, pagesize: 16 }));
  };

  useEffect(() => {
    if (vehicleList?.data?.length > 0) {
      // const mergedVehicleDatas = [
      //   ...vehicleDatas,
      //   ...vehicleList.data.filter(
      //     (vehicle: any) => !vehicleDatas.some(existing => existing.id === vehicle.id)
      //   )
      // ];
      setVehileDatas(vehicleList?.data);
    }
    return () => {
      setVehileDatas([]);
    };
  }, [vehicleList]);

  useEffect(() => {
    if (abortController.current) {
      abortController.current.abort();
    }
    abortController.current = new AbortController();
    const { signal } = abortController.current;

    const payload = {
      pageno: pageno,
      signal: signal,
      pagesize: 16
    };
    dispatch(getVehicleListDetailsAction(payload));
    return () => {
      if (abortController.current) {
        abortController.current.abort();
      }
    };
  }, [pageno]);

  useEffect(() => {
    setApi({
      handlePagination: handleInfinitePagination,
      fetchedData: vehicleDatas,
      count: vehicleList?.count
    });
  }, [vehicleDatas]);

  useEffect(() => {
    return () => {
      dispatch(cleargetVehicleListDetailsAction());
    };
  }, []);

  return {
    handleFilterChange,
    handleInfinitePagination,
    handleOpenVehicle,
    inputRef,
    filter,
    vehicleDatas,
    isScroll,
    setPageno,
    pageno,
    isOpen,
    setIsOpen,
    vehicleDetails
  };
};
